import { render, staticRenderFns } from "./userProfilePopover.vue?vue&type=template&id=25144a42&"
import script from "./userProfilePopover.vue?vue&type=script&lang=js&"
export * from "./userProfilePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports